import { useCallback as D } from "react";
const x = (n, t) => {
  const u = D(
    (i) => {
      var a;
      (a = t == null ? void 0 : t.onBlur) == null || a.call(t, i);
    },
    [t]
  ), s = D(
    (i) => {
      var a;
      n != null && n.show ? c(i, n) : n && k(i, n), (a = t == null ? void 0 : t.onKeyDown) == null || a.call(t, i);
    },
    [t, n]
  );
  return {
    onBlur: u,
    onKeyDown: s
  };
}, c = (n, t) => {
  var s, i, a, g, h, d, y;
  const u = (t == null ? void 0 : t.getVirtualFocus) !== void 0;
  if ((a = (i = (s = t == null ? void 0 : t.getVirtualFocus) == null ? void 0 : s.call(t)) == null ? void 0 : i.onKeyDown) == null || a.call(i, n), n.key === "Tab" && ((d = (h = (g = t == null ? void 0 : t.getVirtualFocus) == null ? void 0 : g.call(t)) == null ? void 0 : h.onBlur) == null || d.call(h, n), t != null && t.getVirtualFocus && (t == null || t.setShowWithReason(!1, n.nativeEvent, "focus"))), n.key === "PageUp" && u && t.setActiveIndex(0), n.key === "PageDown" && u) {
    const l = Math.max((t == null ? void 0 : t.list.current.length) - 1, 0);
    t.setActiveIndex(l);
  }
  if (n.key === "ArrowUp" && (t == null ? void 0 : t.activeIndex) === 0 && (t == null || t.setShowWithReason(!1, n.nativeEvent, "focus")), n.key === "ArrowRight" && n.isDefaultPrevented() && n.target instanceof HTMLInputElement && ((y = n.target.value) != null && y.length)) {
    const l = n.target, w = l.selectionStart ?? 0;
    w < l.value.length && l.setSelectionRange(w + 1, w + 1);
  }
}, k = (n, t) => {
  n.key === "ArrowDown" && (t == null || t.setShowWithReason(!0, n.nativeEvent, "focus"));
};
export {
  x as usePopoverActivatorInteractions
};
